import { RazorInputField } from "../../../../../components/razor-reuse";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../../../components/fragment/modal/ReuseModal";
import styles from "../../../../../styles/dashboard/setting/modals/EnableMFAPassword.module.css";
import RootState from "../../../../../redux/type";
import { verify2FA } from "../../../../../redux/settings";
import { getLoggedInUser } from "../../../../../redux/userAuth";

interface myComponentProps {
  visible?: boolean;
  onClose?: () => void;
  detail?: any;
}

const VerifyMFAOtp = ({ visible, onClose }: myComponentProps) => {
  const dispatch = useDispatch();
  const pinRef = useRef();
  const { loading_mfa } = useSelector((state: RootState) => state.settings); // Get loading state of mfa
  const [completeToken, setCompleteToken] = useState<boolean>(false);
  const [details, setDetails] = useState({
    otp: "",
  });

  // Verify otp function
  const verifyOtpFunc = async () => {
    const payload = {
      obj: {
        secret: details.otp,
      },
    };
    const data = await dispatch(verify2FA(payload) as any);
    if (data?.payload?.data?.status) {
      onClose && onClose();
      dispatch(getLoggedInUser({}) as any);
    }
  };

  // Handle close of the modal
  const handleClose = () => {
    setDetails((prev) => {
      return { ...prev, otp: "" };
    });
    //@ts-ignore
    pinRef?.current?.forEach((input: any) => (input.value = ""));
    onClose && onClose();
    setCompleteToken(false);
  };

  useEffect(() => {
    if (visible) {
      setDetails((prev) => {
        return { ...prev, otp: "" };
      });
    }
  }, [visible]);

  return (
    <>
      <ReuseModal
        visible={visible}
        hideCancel
        onBtnClick={verifyOtpFunc}
        btnLabel="Proceed"
        // hideClose
        title="Enable 2FA"
        onClose={handleClose}
        loading={loading_mfa}
        disable={!completeToken || loading_mfa}
      >
        <div className="auth-confirm-signup-screen-modal-wrap">
          {/* title start */}
          <p className={styles.deleteText}>
            Enter the verification code sent to your google authenticator app
          </p>
          {/* title end */}
          <div className="input-form-wrap">
            <RazorInputField
              pinRef={pinRef as any}
              color="black-light"
              type="pin"
              pinFieldNumber={6}
              value={details?.otp}
              onChange={(param: any) => {
                setDetails((prev) => {
                  return { ...prev, otp: param };
                });
                setCompleteToken(false);
              }}
              onComplete={() => {
                setCompleteToken(true);
                // verifyOtpFunc();
              }}
              // key={otpKey as any}
            />
          </div>
        </div>
      </ReuseModal>
    </>
  );
};

export default VerifyMFAOtp;
